import { Component, inject, Input, TemplateRef } from '@angular/core';

import { NgbActiveModal, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { NotificationModalOptions } from '../../models/notification-modal-options';
import { SpinnerLoaderDirective } from '../../directives/spinner-loader.directive';

@Component({
  selector: 'notification-modal',
  imports: [NgbCollapseModule, SpinnerLoaderDirective],
  templateUrl: './notification-modal.component.html',
  styleUrl: './notification-modal.component.scss'
})
export class NotificationModalComponent {
  @Input() options!: NotificationModalOptions;
  
  activeModal = inject(NgbActiveModal);

  errorCollapsed: boolean = true;

  cancel(): void {
    this.activeModal.close(false);
  }

  confirm(): void {
    this.activeModal.close(true);
  }

  isTemplate() { return this.options.message instanceof TemplateRef; }

}
